import { useEffect, useState } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fpPromise = FingerprintJS.load();

export const useDeviceFingerprint = () => {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        setDeviceId(result.visitorId);
      })
      .catch(() => {
        setDeviceId(null);
      });
  }, []);

  return deviceId;
};
